export default "__VITE_ASSET__DsnzQvVG__"